export type Colors = {
	BACKGROUND: string;
	BACKGROUND_SECONDARY: string;
	BACKGROUND_DARK: string;
	PAPER: string;
	PRIMARY: string;
	SECONDARY: string;
	font_main: string;
	font_status: string;
	font_light: string;
	TABLE_ROW: string;
	TABLE_ROW_HOVER: string;
	BORDER: string;
	DIVIDER: string;
	TOOLTIP_BG: string;
	TOOLTIP_COLOR: string;
	LOGO: string;
};

export enum EThemeName {
	LIGHT = 'light',
	DARK = 'dark',
	LIGHT_GRAY = 'light_gray',
	DARK_GREY = 'dark_grey',
	VAT_LIGHT = 'vat_light',
	VAT_DARK = 'vat_dark',
	NEMAN_LIGHT = 'neman_light',
	NEMAN_DARK = 'neman_dark',
}

export const COLORS_THEMES: Record<EThemeName, Colors> = {
	[EThemeName.LIGHT]: {
		BACKGROUND: '#03629314',
		BACKGROUND_SECONDARY: '#03629340',
		BACKGROUND_DARK: '#004468',
		PAPER: '#ffffff',
		PRIMARY: '#016193',
		SECONDARY: '#bdd2df',
		font_main: '#000000c0',
		font_status: '#000000a0',
		font_light: '#000000',
		TABLE_ROW: '#03629314',
		TABLE_ROW_HOVER: '#03629338!important',
		BORDER: '#d4dde3',
		DIVIDER: '#e4eaee',
		TOOLTIP_BG: '#2c3e50',
		TOOLTIP_COLOR: '#ffffffe6',
		LOGO: '/img/EAS-logo-new.svg',
	},
	[EThemeName.DARK]: {
		BACKGROUND: '#111111',
		BACKGROUND_SECONDARY: '#053c59',
		BACKGROUND_DARK: '#004468',
		PAPER: '#001825',
		PRIMARY: '#016193',
		SECONDARY: '#0A3D62',
		font_main: '#ffffffd0',
		font_status: '#ffffffa0',
		font_light: '#ffffff',
		TABLE_ROW: '#03629314',
		TABLE_ROW_HOVER: '#03629338!important',
		BORDER: '#1c3a4d',
		DIVIDER: '#152f40',
		TOOLTIP_BG: '#1a3a4f',
		TOOLTIP_COLOR: '#ffffffd0',
		LOGO: '/img/EAS-logo-new.svg',
	},
	[EThemeName.LIGHT_GRAY]: {
		BACKGROUND: '#eaeaea',
		BACKGROUND_SECONDARY: '#c3c6c8',
		BACKGROUND_DARK: '#5f6a6a',
		PAPER: '#ffffff',
		PRIMARY: '#5f6a6a',
		SECONDARY: '#9aa0a6',
		font_main: '#000000c0',
		font_status: '#000000a0',
		font_light: '#000000',
		TABLE_ROW: '#f0f0f0',
		TABLE_ROW_HOVER: '#e5e5e5!important',
		BORDER: '#c8cacc',
		DIVIDER: '#d8dadc',
		TOOLTIP_BG: '#3d4a4a',
		TOOLTIP_COLOR: '#ffffffe6',
		LOGO: '/img/EAS-logo-gray.svg',
	},
	[EThemeName.DARK_GREY]: {
		BACKGROUND: '#1a1a1e',
		BACKGROUND_SECONDARY: '#3a3d40',
		BACKGROUND_DARK: '#2c3033',
		PAPER: '#242628',
		PRIMARY: '#7a8288',
		SECONDARY: '#4b5259',
		font_main: '#ffffffd0',
		font_status: '#ffffffa0',
		font_light: '#ffffff',
		TABLE_ROW: '#2a2a2e',
		TABLE_ROW_HOVER: '#35353a!important',
		BORDER: '#3c3e42',
		DIVIDER: '#323436',
		TOOLTIP_BG: '#48494d',
		TOOLTIP_COLOR: '#ffffffd0',
		LOGO: '/img/EAS-logo-gray.svg',
	},
	[EThemeName.VAT_LIGHT]: {
		BACKGROUND: '#f0f7f4',
		BACKGROUND_SECONDARY: '#b2dfdb',
		BACKGROUND_DARK: '#00695c',
		PAPER: '#ffffff',
		PRIMARY: '#00796b',
		SECONDARY: '#b2dfdb',
		font_main: '#000000c0',
		font_status: '#000000a0',
		font_light: '#000000',
		TABLE_ROW: '#e0f2f1',
		TABLE_ROW_HOVER: '#b2dfdb!important',
		BORDER: '#b2ccc9',
		DIVIDER: '#d7ebe9',
		TOOLTIP_BG: '#004d40',
		TOOLTIP_COLOR: '#ffffffe6',
		LOGO: '/img/EAS-logo-vat.svg',
	},
	[EThemeName.VAT_DARK]: {
		BACKGROUND: '#0d1b19',
		BACKGROUND_SECONDARY: '#1a3c36',
		BACKGROUND_DARK: '#00332c',
		PAPER: '#112b26',
		PRIMARY: '#26a69a',
		SECONDARY: '#004d40',
		font_main: '#ffffffd0',
		font_status: '#ffffffa0',
		font_light: '#ffffff',
		TABLE_ROW: '#152f2a',
		TABLE_ROW_HOVER: '#1f3d37!important',
		BORDER: '#1f4a42',
		DIVIDER: '#183832',
		TOOLTIP_BG: '#244a42',
		TOOLTIP_COLOR: '#ffffffd0',
		LOGO: '/img/EAS-logo-vat.svg',
	},
	[EThemeName.NEMAN_LIGHT]: {
		BACKGROUND: '#fff', // сделать немного темнее #dbe5ef
		BACKGROUND_SECONDARY: '#dbe5ef',
		BACKGROUND_DARK: '#0f172a',
		PAPER: '#ffffff', // сделать светлее#ecf3f9
		PRIMARY: '#0f172a',
		SECONDARY: '#e8f2ff',
		font_main: '#0f172ac0',
		font_status: '#0f172aa0',
		font_light: '#0f172a',
		TABLE_ROW: '#ecf3f9', // сделать немного темнее #ecf3f9
		TABLE_ROW_HOVER: '#e8f2ff!important',
		BORDER: '#dbe5ef',
		DIVIDER: '#e7eff8',
		TOOLTIP_BG: '#0f172a',
		TOOLTIP_COLOR: '#ffffffe6',
		LOGO: '/img/EAS-logo-neman.svg',
	},
	[EThemeName.NEMAN_DARK]: {
		BACKGROUND: '#0d1525',
		BACKGROUND_SECONDARY: '#1a2744',
		BACKGROUND_DARK: '#0f172a',
		PAPER: '#111827',
		PRIMARY: '#3399ff',
		SECONDARY: '#1e3a5f',
		font_main: '#ffffffd0',
		font_status: '#ffffffa0',
		font_light: '#ffffff',
		TABLE_ROW: '#151f30',
		TABLE_ROW_HOVER: '#1a2744!important',
		BORDER: '#263248',
		DIVIDER: '#1e2d42',
		TOOLTIP_BG: '#263248',
		TOOLTIP_COLOR: '#ffffffd0',
		LOGO: '/img/EAS-logo-neman.svg',
	},
};

const isValidTheme = (value: string | null): value is EThemeName =>
	Object.values(EThemeName).includes(value as EThemeName);

const isNemanHost =
	typeof window !== 'undefined' &&
	(window.location.hostname === 'cc.neman.ee' || window.location.hostname === 'cc-dev.neman.ee');

const getSavedTheme = (): EThemeName => {
	if (isNemanHost) {
		return EThemeName.NEMAN_LIGHT;
	}
	try {
		if (typeof window !== 'undefined') {
			const saved = localStorage.getItem('theme');
			if (saved && isValidTheme(saved)) {
				return saved;
			}
		}
	} catch (_) {
		// ignore read errors and fallback to default theme
	}
	return EThemeName.LIGHT;
};

export const COLORS: Colors = COLORS_THEMES[getSavedTheme()];

export const setTheme = (theme: EThemeName): void => {
	const nextTheme: EThemeName = isValidTheme(theme) ? theme : EThemeName.LIGHT;
	try {
		if (typeof window !== 'undefined') {
			localStorage.setItem('theme', nextTheme);
		}
	} catch (_) {
		// ignore write errors
	}
};

export const getTheme = (): EThemeName => getSavedTheme();

export type ColorKey = keyof Colors;
export type ColorValue = Colors[ColorKey];
